export const electronicDrawing = {
  // Hero Banner
  heroTitleLine1: 'One-stop Electronic Drawing',
  heroTitleLine2:
    '<span class="color-blue">Trusted Automated Processing</span> Solution',
  heroSubTitle:
    'Make your drawing processing smarter, faster, more accurate and more reliable',
  tagTraceable: 'Traceable',
  tagAuditable: 'Auditable',
  consultNow: 'Consult Now',
  viewDetail: 'View Details',
  modalTitle: 'Consult Electronic Drawing Solution',

  // Tags
  tagSdkEngine: 'SDK Core Engine',
  tagDwgToPdf: 'DWG to PDF SDK',
  tagCadExport: 'CAD One-click Export',

  // Core Products
  coreProductsTitleL1: 'Core Products',
  coreProductsTitleL2: 'Cover Full-chain Drawing Processing',
  coreProduct1Title: 'Accurate Drawing Rendering',
  coreProduct1Desc:
    'Lines, annotations, and layer information are fully preserved with pixel-level original accuracy',
  coreProduct2Title: 'Smart Frame Recognition',
  coreProduct2Desc:
    'Standard, extended, and rotated frames can all be automatically recognized without manual intervention',
  coreProduct3Title: 'Multi-frame Mixed Export',
  coreProduct3Desc:
    'Different frames in the same drawing can be exported together for batch processing',

  // Intelligent Platform
  platformSubLabel: 'Intelligent Processing Platform',
  platformTitleL1: 'Intelligent Digital Drawings Processing Platform',
  platformTitleL2: '',
  platformSubTitle:
    'CAD/PDF Drawing Intelligent Labeling System + Trusted High-Quality Data Processing System',

  platformFeature1Title: 'Support Two Major Industries',
  platformFeature1Desc:
    'Deep coverage of building construction & mechanical manufacturing',

  platformFeature2Title: 'Smart Frame Splitting',
  platformFeature2Desc:
    'Different frames in the same drawing can be split together',

  platformFeature3Title: 'Intelligent Structured Information Extraction',
  platformFeature3Desc:
    'Including but not limited to title block info, BOM info, connected components, etc.',

  platformFeature4Title: 'Smart Label Classification',
  platformFeature4Desc:
    'Innovative intelligent classification processing method maximizes AI hallucination elimination',

  platformFeature5Title: 'Reliable, Low Hallucination',
  platformFeature5Desc:
    'Through confidence evaluation, feedback system, and information traceability, minimize hallucinations while fully leveraging AI',

  // Enterprise Service
  enterpriseServiceTitleL1: 'Empowering Enterprise Digital Drawing',
  enterpriseServiceTitleL2: 'At Your Service',
  serviceCard1Label: 'Rapid Implementation',
  serviceCard2Label: 'Professional Team',
  serviceCard3Label: 'Professional Service',
};
